'use client';
import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { theme } from 'styles/theme';

const LinkOnly = ({
                    onSubmit,         // Form submission handler
                    onClick,          // Click event handler
                    text,             // Text to display on the button
                    src,              // Link URL
                    img,              // Background image for the button
                    hoverImg,         // Hover state background image
                    icon,             // Icon to display
                    hoverIcon,        // Icon for hover state
                    fontSize,         // Font size
                    fontWeight,       // Font weight
                    color,            // Text color
                    hovercolor,       // Text color on hover
                    letterSpacing,    // Letter spacing
                    lineHeight,       // Line height
                    margin,           // Margin around the button
                    marginSm,         // Margin for small devices
                    padding,          // Padding inside the button
                    background,       // LinkOnly background color
                    hoverbackground,  // Hover state background color
                    borderRadius,     // Border radius
                    border,           // Border styles
                    borderColor,      // Border color
                    width,            // LinkOnly width
                    height,           // LinkOnly height
                    target,           // Target attribute for links
                    className,        // Additional classes
                    transition,       // Transition effect duration and timing
                    boxShadow,        // Shadow styles
                    zIndex,           // Z-index
                    underline,
                      onClickHandle,
                }) => {

    const onClickHandleCLick = (e) => {
        if (onClickHandle) {
            onClickHandle(e);
        }
    }


    return (
        <StyledBtn
            onClick={onClick}
            onSubmit={onSubmit}
            className={`${className ? className : ''} dc-btn-link`}
            fontSize={fontSize}
            fontWeight={fontWeight}
            color={color}
            background={background}
            hovercolor={hovercolor}
            hoverbackground={hoverbackground}
            lineHeight={lineHeight}
            letterSpacing={letterSpacing}
            margin={margin}
            marginSm={marginSm}
            padding={padding}
            border={border}
            borderRadius={borderRadius}
            borderColor={borderColor}
            width={width}
            height={height}
            img={img}
            hoverImg={hoverImg}
            zIndex={zIndex}
            boxShadow={boxShadow}
            transition={transition}
            underline={underline}
        >

            {
                icon ?

                    <Link prefetch={true} className={'icon-hover-main'} href={src || '/'} target={target ? target : '_self'}>
                        <div className="d-flex">
                            <span>{text}</span>
                            <span>{text}</span>
                        </div>
                        <svg width="77" height="22" viewBox="0 0 77 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M66.0662 1L75.9999 11" stroke="white" strokeWidth="2" strokeLinecap="round" />
                            <path d="M66.0662 21L75.9999 11" stroke="white" strokeWidth="2" strokeLinecap="round" />
                            <path d="M75.5033 11H1" stroke="white" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </Link>
                        :
                    <Link onClick={onClickHandleCLick} onTouc prefetch={true} href={src || '/'} target={target ? target : '_self'} className={'link-only'}>
                        <span>{text}</span>
                        <span>{text}</span>
                    </Link>

            }

        </StyledBtn>
    );
};

const StyledBtn = styled.div`
    &.dc-btn-link {
        margin: ${props => props.margin || '0'};
        width: ${props => props.width || 'fit-content'};
        height: ${props => props.height || 'auto'};
        cursor: pointer;
        position: relative;
        z-index: ${props => props.zIndex || 0};
        transition: ${props => props.transition || theme.transition};
        overflow: hidden;
        display: inline-block;

        a {
            display: inline-flex;
            width: 100%;
            height: 100%;
            align-items: center;
            justify-content: center;
            font-size: ${props => props.fontSize || '1.25rem'};
            font-weight: ${props => props.fontWeight || '700'};
            color: ${props => props.color || theme.colors.black};
            letter-spacing: ${props => props.letterSpacing || '0'};
            line-height: ${props => props.lineHeight || '1.5rem'};
            background: ${props => `url(${props.img || ''})`} no-repeat center/cover;
            border-color: ${props => props.borderColor || 'transparent'};
            position: relative;
            overflow: hidden;
            transition: ${props => props.transition || theme.transition};
            &.icon-hover-main{
                display: inline-flex;
                gap: 30px;
                svg{
                    transition: ${theme.transition};
                    will-change: transform;
                    path{
                        transition: ${theme.transition};
                        
                    }
                }
            }
            span{
                position: relative;
                transition: ${props => props.transition || theme.transition};
                transform-style: preserve-3d;
                text-decoration: ${props => props.underline ? 'underline' : 'none'};
                
                &:first-child{
                    transform: translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
                }
                &:last-child{
                    position: absolute;
                    top: 102%;
                    transform: translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
                }
            }
            &:hover {
                color: ${props => props.hoverbackground+' !important' || theme.colors.black};
                
                span{
                    &:first-child{
                        transform: translate3d(0px, -100%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
                        
                    }
                    &:last-child{
                        transform: translate3d(0px, -100%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
                    }
                }
            }
        }

   
    }
`;

export default LinkOnly;
